var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBelarus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_33126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95669 11.1304L3.65234 8.76402L4.95669 6.43475L6.26103 8.76402L4.95669 11.1304Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34829 11.1304L1.04395 8.76402L2.34829 6.43475L3.65263 8.76402L2.34829 11.1304Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95669 17.5652L3.65234 15.1988L4.95669 12.8696L6.26103 15.1988L4.95669 17.5652Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34829 17.5652L1.04395 15.1988L2.34829 12.8696L3.65263 15.1988L2.34829 17.5652Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26138 2.3293L5.8921 1.66986C5.22976 2.0623 4.60852 2.51666 4.03613 3.02497L4.95704 4.69564L6.26138 2.3293Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95702 19.3043L4.02637 20.9663C4.59824 21.4753 5.21905 21.9304 5.88112 22.3236L6.26141 21.6336L4.95702 19.3043Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30469 15.1305V23.0459C8.74698 23.6598 10.3338 24 12.0003 24C17.1599 24 21.5584 20.7435 23.254 16.1739L7.30469 15.1305Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.254 16.1739C23.7363 14.8739 24.0003 13.4678 24.0003 12C24.0003 5.37263 18.6277 0 12.0003 0C10.334 0 8.74698 0.339984 7.30469 0.953813V16.1739H23.254V16.1739Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_33126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

export default __webpack_public_path__ + "media/48e1c7bf.svg";
export { SvgBelarus as ReactComponent };